import script from "./AiButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./AiButton.vue?vue&type=script&lang=ts&setup=true"

import "./AiButton.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__